import getParamUrl from './getParamUrl'

export const modulesWithParams = [
  'need-module',
  'comparator',
  'price-configurator'
]

export const listParamUrl = {
  socialAdvertising: 'socialAdvertising',
}

export default {
  name: 'manage-param-url-module',

  modalToOpen() {
    const target = document.querySelector('.' + 'modals')
    if (target) {
      const attrModule = target.getAttribute('js-manage-param-url-module-area')
      if (attrModule) {
        return getParamUrl(listParamUrl.socialAdvertising)
      }
    }
  }
}
